<template>
  <div>
    <mt-loading-animation-linear v-if="!loaded" />

    <template v-else>
      <h2 class="cabinet__title">{{ respondent.full_name }} - {{ this.respondent?.email || 'планы оценок' }}</h2>

      <div class="respondents-table" :class="{'respondents-table-loading': respondentsLoading}">
        <div class="respondents-table__header">
          <app-tooltip top>
            <template #default>Экспорт</template>
          </app-tooltip>

          <mt-filters
            style="margin-left: auto;"
            v-model:cols="cols"
            v-model:filters="computedFilters"
            v-model:sort="sort"
            v-model:search="search"
            :cols-visibility="false"
            :filter-visibility="true"
            :hasData="tableData?.rows?.length ? true : false"
          />
          <!-- del @change="updateExpPlanList" -->
        </div>
        <div class="respondents-table__body">
          <div
            class="respondents-table__wrapper"
            ref="table"
          >
            <table>
              <thead>
              <tr>
                <th class="respondents-table__border-left">План оценки</th>
                <th class="respondents-table__border-left">Описание плана</th>
                <th class="respondents-table__border-left">Дата окончания плана</th>
                <th class="respondents-table__border-left" :colspan="tableData.max" style="text-align: center">Задания</th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="(row, index) in tableData.rows"
                :key="index"
              >
                <td class="respondents-table__align-center">
                  <router-link :to="{
              name: 'AddEdit1',
              params: {
                planUuid: row.uuid,
              },
            }">
                    {{ row.name }}
                  </router-link>
                </td>
                <td>{{ row.description ?? "-" }}</td>
                <td>{{ row.date_to ?? "-" }}</td>

                <td v-for="(test,index) in row.tests" :key="index">
                  <div class="test-cell" v-if='test && test.type !== "confirmation"'>
                    <div class="test-cell__header">
                      <mtSvg
                        class="test-cell__icon"
                        color="#00788C"
                        :name="test.icon"
                        @click="showTaskDialog(test.uuid)"
                      />
                      <div class="test-cell__title"> {{ test.title }}</div>
                    </div>
                    <div class="test-cell__body">
                      <template v-if="!test.sessionUuid">
                        <div class="mt-data-table__cell__more">
                          <template v-if="!test.currentScore && !test.totalScore">
                            -
                          </template>
                          <template v-else>
                            {{ !test.isSet && !test.currentScore ? "-" : (test.currentScoreWithWeight ? test.currentScoreWithWeight : test.currentScore)
                            }}
                            из
                            {{ test.totalScoreWithWeight ? test.totalScoreWithWeight : test.totalScore }}
                          </template>
                        </div>
                      </template>
                      <template v-else>
                        <div class="mt-data-table__cell__wrap">
                          <component
                            class="mt-data-table__cell__more"
                            is="div"
                            :class="{
                              'mt-data-table__cell__more_failed': test.isFailed,
                              'mt-data-table__cell__more_expert': test.type === 'expert' && !assessmentPlan.isCompleted,
                              'c-pointer': test.type === 'expert' && !assessmentPlan.isCompleted
                            }"
                            @click="showTaskSingle(row,test,respondent)"
                          >
                            <template v-if="!test.currentScore && !test.totalScore">
                              -
                            </template>
                            <template v-else>
                              {{ !test.isSet && !test.currentScore ? "-" : (test.currentScoreWithWeight ? test.currentScoreWithWeight : test.currentScore)
                              }}
                              из
                              {{ test.totalScoreWithWeight ? test.totalScoreWithWeight : test.totalScore }}
                            </template>
                          </component>
                          <button
                            v-if="test.reports.length"
                            @click="openDownloadReportModal(respondent.uuid, test)"
                          >
                            <mtSvg
                              name="download"
                              color="#00788C"
                            />
                          </button>
                        </div>
                      </template>
                      <img
                        class="mt-data-table__cell__notification"
                        src="/img/icons/notification.svg"
                        v-if="test.hasNotifications"
                        alt=""
                      />
                      <div v-if="test.sessionStartDate"> {{ test.sessionStartDate }}</div>
                    </div>
                  </div>
                  <span v-else> - </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>
        <mt-pagination
          class="mt-data-table__pagination"
          v-if="plans?.meta.total"
          :total="plans?.meta.total"
          :page="plans.meta.current_page"
          :perPage="plans.meta.per_page"
          @change="getPlans"
        />
      </div>
    </template>

    <teleport to="body">
      <mt-dialog
        class="custom-assessment"
        size="md"
        v-model="taskDialog"
      >
        <mt-loading-animation-linear v-if="taskLoading" />
        <template v-else>
          <h3 class="custom-assessment__expander__title">{{ chosenTask.name }}</h3>
          <p
            class="custom-assessment__expander__text"
            v-show="chosenTask.description"
          >
            {{ chosenTask.description }}</p>
          <template v-if="chosenTask.materials.length">
            <h2 class="custom-assessment__expander__file-title">Файлы</h2>
            <div class="card mt-2">
              <file-download-card :links="chosenTask.materials" />
            </div>
          </template>
        </template>
      </mt-dialog>

      <download-report-popover
        :visibility="isDownloadReportVisible"
        :reports="clipboardTask?.reports"
        :view_download_html="true"
        @close="closeDownloadReportModal"
        @download="downloadReport"
        @downloadHTML="downloadReportHTML"
      />
    </teleport>

    <router-view />
  </div>
</template>

<script>
import { respondentPlansAdapter } from "@/adapters/assessmentPlans/expRespPlans.adapter";
import { mapActions, mapMutations, mapState } from "vuex";
import MtSvg from "@/components/UI/mtSvg/index.vue";
import MtCheckbox from "@/components/UI/mtCheckbox/index.vue";
import { dragscroll } from "vue-dragscroll";
import { taskSingleAdapter } from "@/adapters/assessmentPlans/tasks/tasks.adapter";
import MtLoadingAnimationLinear from "@/components/UI/mtLoadingAnimationLinear/mtLoadingAnimationLinear.vue";
import FileDownloadCard from "@/components/workspace/assessmentPlans/plans/fileDownloadCard/index.vue";
import MtDialog from "@/components/UI/mtDialog/mtDialog.vue";
import { roundNumber } from "@/services/Mathe";
import MtPagination from "@/components/UI/mtPagination/mtPagination.vue";
import DownloadReportPopover from "@/components/workspace/testLibrary/results/DownloadReportPopover/index.vue";
import api from "@/network";
// import externalApi from "@/network/external";
import MtButton from "@/components/UI/mtButton/index.vue";
import ExportIcon from "@/components/icons/ExportIcon.vue";
import AppTooltip from "@/components/UI/AppTooltip/AppTooltip.vue";
import MtFilters from "@/components/UI/mtFilters/mtFilters.vue";
import MtChip from "@/components/UI/mtChip/index.vue";
import usePlansStore from "@/store/plans.store";
import useRespondentsStore from "@/store/respondents.store";

export default {
  name: "Cabinet",
  directives: { dragscroll },
  components: {
    MtChip,
    MtFilters,
    AppTooltip,
    ExportIcon,
    MtButton, DownloadReportPopover, MtPagination, MtDialog, FileDownloadCard, MtLoadingAnimationLinear, MtCheckbox, MtSvg
  },
  data: () => ({
    plans: {
      data: [],
      meta: {
        filters: {}
      }
    },
    respondent: {
      full_name: ""
    },

    cols: [
      {
        "title": "Наименование плана",
        "stub": "name",
        "filter": "string",
        "filterable": true,
        "sortable": true
      },
      {
        "title": "Наименование задания",
        "stub": "tests.name",
        "filter": "string",
        "filterable": true,
        "sortable": false
      },
      {
        "title": "Дата окончания плана",
        "stub": "date_to",
        "filterable": false,
        "sortable": true
      }
    ],
    search: {},
    sort: {},
    filtersSettings: {},

    activeCustomAssessment: {},
    activeTestColumn: null,
    respondentsLoading: false,
    chosenTask: {},

    taskDialog: false,
    taskLoading: true,

    isDownloadReportVisible: false,
    showInfo: true,
    hasScroll: false,
    clipboardUserUuid: null,
    clipboardTask: null,
    loaded: false
  }),
  computed: {
    ...mapState("assessmentPlans/plan", ["assessmentPlan", "filters"]),
    ...mapState("assessmentPlans/plan/task", ["mark", "marksChanged"]),

    computedFilters: {
      get() {
        return this.filters;
      },
      set(newValue) {
        this.updateFilters(newValue);
      }
    },

    tableData() {
      let rows = [];

      for (let i = 0; i < this.plans.data.length; i++) {
        let plan = this.plans.data[i];
        let row = {
          uuid: plan.uuid,
          name: plan.name,
          description: plan.description,
          date_to: plan.date_to,
          tests: []
        };

        for (let j = 0; j < plan.tests.length; j++) {
          let test = plan.tests[j];
          row.tests.push(test);
        }

        rows.push(row);
      }

      const max = Math.max(...rows.map(row => row.tests.length));

      rows = rows.map((row) => {
        while (row.tests.length < max) {
          row.tests.push(null);
        }
        return row;
      });


      return {
        max: max,
        rows: rows
      };
    }
  },
  setup() {
    const plansStore = usePlansStore();
    const respondentsStore = useRespondentsStore();

    return {
      plansStore,
      respondentsStore
    };
  },
  methods: {
    ...mapActions('results', ['exportResultsReportHTML']),
    ...mapActions(["fetchAdministrator"]),
    ...mapActions("assessmentPlans/plan", ["fetchPlan"]),
    ...mapActions("assessmentPlans/plan/task", ["fetchTask"]),
    ...mapActions("breadcrumbs", ["setBreadcrumbs"]),
    ...mapMutations("assessmentPlans/plan", ["updateFilters"]),

    showTaskSingle(row, test, respondent) {
      Promise.all([
        this.respondentsStore.getRespondents(row.uuid),
        this.plansStore.getSingle(row.uuid)
      ]).then(() => {
        this.$router.push({
          name: "RespondentCabinetTaskSingle",
          params: { planUuid: row.uuid, taskUuid: test.uuid, respondentUuid: respondent.uuid }
        });
        this.activeCustomAssessment = test;
      });
    },

    async getPlans(pagination) {
      let filters = this.filters;

      let params = {
        page: pagination?.page || this.plans.meta.current_page,
        per_page: pagination?.perPage || this.plans.meta.per_page,
        settings: { ...this.sort }
      };


      if (filters.length) {
        params = {
          ...params,
          settings: {
            ...params.settings,
            filters: filters
          }
        };
      }

      if (!!this.search.value) {
        params.settings["value"] = this.search.value;
      }

      const { data } = await this.$workspaceApi.assessmentPlans.planListTable.getSingleRespondentPlans(this.$route.params.respondentUuid, { params });
      this.plans.data = respondentPlansAdapter(data.data);
      this.plans.meta = data.meta;
    },

    async getRespondentInfo() {
      const { data } = await this.fetchAdministrator({ uuid: this.$route.params.respondentUuid });
      this.respondent = data.data;
    },

    async initBreadcrumbs() {
      let breadcrumbs = this.$route.meta.breadcrumbs;

      breadcrumbs.forEach(item => {
        if (item.link === "RespondentCabinet") {
          item.value = this.respondent.full_name;
        }
        if (item.link === "AddEdit1") {
          item.value = this.assessmentPlan.name;
          item.params = {
            uuid: this.$route.params.planUuid
          };
        }

        return item;
      });

      await this.setBreadcrumbs([
        ...breadcrumbs,
        { value: this.respondent.full_name },
        { value: "Результаты" }
      ]);
    },

    openDownloadReportModal(userUuid, task) {
      this.isDownloadReportVisible = true;
      this.clipboardUserUuid = userUuid;
      this.clipboardTask = task;
    },

    updatePlanList() {
      this.plans.current_page = 1;
      this.getPlans();
    },

    closeDownloadReportModal() {
      this.isDownloadReportVisible = false;
    },

    async downloadReport({ format, variants, titles }) {
      const payload = [
        {
          format,
          variants,
          selected_results_report: [{ "uuid_session": this.clipboardTask.sessionUuid, "uuid_user": this.clipboardUserUuid }]
        }
      ];
      const response = await api.post("export/results", payload);

      if (response.data?.url) {

        const reportLink = response.data.url;
        const fileNameInfo = response.data.FileNameInfo;
        const type = format;
        const isGroup = variants.length > 1;

        if (isGroup) {
          window.open(reportLink, "_blank");
        } else {
          // const response = await externalApi.get(`${reportLink}`, { responseType: "blob" });
          const response = await api.get(`export/downloadReport`, { responseType: 'blob', params: { reportLink } })

          if (response.data.size) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");

            link.href = url;

            let fileName = [fileNameInfo["FullName"], fileNameInfo["TestName"], titles[0], fileNameInfo["TestNumber"]].filter(Boolean).join("_") + "." + format;

            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
          } else {
            this.$toast.error("Отчёт не найден");
          }
        }
      }
    },

    async downloadReportHTML({ variant }) {
      const payload =
          {
            uuid_session: this.clipboardTask.sessionUuid,
            variant: variant
          };

      await this.exportResultsReportHTML(payload).then((response) => {
        if (response.data?.url) {
          window.open(response.data.url, "_blank");
        }
      });
    },

    async showTaskDialog(taskUuid) {
      this.taskDialog = true;
      this.taskLoading = true;

      const { data } = await this.fetchTask({
        uuidPlan: this.$route.params.planUuid,
        uuid: taskUuid
      });

      this.chosenTask = taskSingleAdapter(data.data);
      this.taskLoading = false;
    },

    toggleCriteriasDisplay(test) {
      if (this.activeTestColumn === test.uuid) {
        this.activeTestColumn = null;
        return;
      }
      this.activeTestColumn = test.uuid;
    }
  },
  mounted() {
    Promise.all([
      this.fetchPlan({
        uuid: this.$route.params.planUuid
      }),
      this.getPlans(),
      this.getRespondentInfo()
    ]).finally(() => {
      this.initBreadcrumbs();
      this.loaded = true;
      console.log('respondent', respondent)
    });
  },
  watch: {
    mark(val) {
      if (this.marksChanged) {
        this.getPlans();
      }
      let totalScore = val.scales ? val.scales.reduce((acc, scale) => {
        return acc + scale.value;
      }, 0) : [];
      this.activeCustomAssessment.currentScore = roundNumber(totalScore);
    },
    search: {
      handler: function() {
        this.updatePlanList();
      },
      deep: true
    },
    filters: {
      handler: function() {
        console.info("watch filters");
        this.updatePlanList();
      },
      deep: true
    },
    sort: {
      handler: function() {
        this.updatePlanList();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.respondents-table {
  background: #FFFFFF;
  border: 1px solid #DFE0EB;
  border-radius: 8px;
  position: relative;
  width: 100%;
  max-width: 100%;
  transition: .3s opacity;

  &-loading {
    opacity: 0.7;
    pointer-events: none;
  }

  &__header {
    gap: 15px;
    height: 57px;
    display: flex;
    align-items: center;
    padding: 0 24px;

    &__toggler {
      width: 0;
      height: 0;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-left: 8px solid $green;
      margin-left: 10px;

      &_active {
        transform: scale(-1);
      }
    }
  }

  .test-cell {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    &__header {
      font-size: 12px;
      font-weight: bold;
      display: flex;
      justify-content: center;
      gap: 10px;
    }

    &__body {
      display: flex;
      gap: 10px;
      flex-direction: column;
      justify-content: center;
    }
  }

  th, td {
    padding: 12px 10px;
    text-align: left;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.01em;
    color: #252733;
    vertical-align: top;
    border: 1px solid #DFE0EB;
    border-collapse: collapse;

    &.respondents-table__align-center {
      text-align: center;
    }

    a {
      text-decoration: underline;
      color: #252733;
    }
  }

  th {
    text-align: center;
    white-space: nowrap;
    background: #F0F1F7;
    box-shadow: inset 0px -1px 0px #E6E7E9;
  }

  tbody tr > * {
    border-bottom: 1px solid #DFE0EB;
    min-width: 130px;
  }

  table {
    width: 100%;
  }

  &__pagination {
    padding: 0 20px;
    justify-content: flex-end;
    min-height: 60px;
  }
}
.cabinet__title {
  font-weight: bold;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0.4px;
  color: #252733;
  margin-bottom: 35px;
}

.mt-data-table__cell__wrap {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
</style>
